import React, { useState, useEffect, useContext } from 'react'
import { Pagination } from 'antd'
import { ListSearch, ListTable, ListTableContext, EasyIcon, EasyImg, EasyModal, EditPage } from 'src/components'
import { getFileUrl } from 'enasops/utils/axios'
import { getTableOperateColumns } from 'src/components/root/tabler'
import { Divider } from 'antd'
import { appStore } from 'src/stores'

const CardTable = () => {
  const state = useContext(ListTableContext)

  const [appTypes, setAppTypes] = useState<{ label: string, value: number }[]>([])
  useEffect(() => {
    appStore.getEnums(['AppType']).then(res => {
      res && setAppTypes(appStore.getEnumOptions('AppType'))
    })
  }, [])

  const getVersionBtn = (code: string, slot: React.ReactNode) => {
    const versionBtn = state?.tableConfig.RowBtns.filter((btn: any) => btn.FORM_CODE === code)
    if (versionBtn.length) {
      return getTableOperateColumns(versionBtn.map((btn: any) => ({
        ...btn,
        __RENDER_SLOT__: () => slot
      })))[0]
    }
    return { render: () => slot }
  }

  const getOperateColumn = () => {
    const validBtns = state?.tableConfig.RowBtns.slice(0, 5)
    return getTableOperateColumns(validBtns)[0]
  }

  return (
    <React.Fragment>
      <div className='op100__table-main'>
        <EasyModal
          modal={{ title: 'OP033' }}
          slot={
            <React.Fragment>
              <EasyIcon type='PlusOutlined' size={56} />
              <p>新增应用</p>
            </React.Fragment>
          }
          slotClass='table-card'
          slotStyle={{ display: 'flex' }}
        >
          <EditPage formCode='OP033' />
        </EasyModal>
        {
          state.tableData.dataSource.map((item: any) => {
            const img = item.LOGO_IMG ? JSON.parse(item.LOGO_IMG) : []
            const type = appTypes.find(at => at.value === item.TYPE)?.label
            return (
              <div key={item.ID} onClick={() => state.setSelectedRow(item)} className='table-card'>
                <EasyImg src={require('enasops/assets/op/100/bg.png')} />
                <div className='table-card__header'>
                  <EasyImg src={getFileUrl(img?.[0]?.FilePath)} />
                  <div className='flex-1'>
                    <div className='table-card__header-title'>
                      <span>{item.TITLE}</span>
                      <span>{`(${item.CODE})`}</span>
                    </div>
                    <div className='table-card__header-version'>
                      <EasyImg src={require('enasops/assets/op/100/pc.png')} />
                      {getVersionBtn('OP071', <span>V {item.VERSION || '--'}</span>)?.render(undefined, item)}
                      <Divider type='vertical' />
                      <EasyImg src={require('enasops/assets/op/100/mobile.png')} />
                      {getVersionBtn('OP073', <span>V {item.MOBILE_VERSION || '--'}</span>)?.render(undefined, item)}
                    </div>
                  </div>
                  <div className='table-card__header-type'>{type}</div>
                </div>
                <div className='table-card__desc'>{item.DESCRIPTION}</div>
                <div className='table-card__btns'>
                  {getOperateColumn()?.render(undefined, item)}
                </div>
              </div>
            )
          })
        }
      </div>
      <div className='op100__table-pagination'>
        <Pagination
          size='small'
          {...state.paginationOption}
          onChange={(page, pageSize) => state.setPagination({ current: page, pageSize })}
        />
      </div>
    </React.Fragment>
  )
}

const ChartTable = () => {
  return (
    <div className='op100__table'>
      <ListSearch preventAutoConfig preventAutoData formCode='OP028' />
      <ListTable
        cardMode
        cardRender={() => <CardTable />}
        formCode='OP028'
      />
    </div>
  )
}

export default ChartTable